export function postToDataLayer(data: any) {
    if (!window.dataLayer) {
        return;
    }

    window.dataLayer.push(data);
}

export function logErrorToDataLayer(errorType: string) {
    postToDataLayer({
        event: 'error',
        errorData: {
            errorType,
            url: typeof window !== 'undefined' && window.location.href
        }
    });
}
